import { inject, observer } from "mobx-react";
import CustomBuildComponent from "../../components/UserManagement/CustomBuild/CustomBuild";

const CustomBuild = inject(
  "userStore",
  "sharedStore"
)(observer(CustomBuildComponent));

export default CustomBuild;
